import { AxiosService } from '@/shared/utils'
import { AxiosRequestConfig } from 'axios'
import { BrushMapReport, SendReportToTelegramBot } from '@/shared/types'

class BrushReportApi extends AxiosService implements SendReportToTelegramBot {
  constructor(config?: AxiosRequestConfig) {
    super(config)
  }

  public getReports(patientId: number) {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/brush-maps/list',
      params: {
        patient_id: patientId,
      },
    })
  }

  public getReport(reportId: number) {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/brush-maps/',
      params: {
        id: reportId,
      },
    })
  }

  public saveReport(patientId: number, report: BrushMapReport) {
    const { brushesFirm, teeth, firstGroupColors, secondGroupColors } = report

    return this.axiosCall({
      method: 'post',
      url: '/api/web/admin/brush-maps/',
      data: {
        date_at: new Date(),
        brushesFirm: brushesFirm,
        teeth: teeth,
        firstGroupColors: firstGroupColors,
        secondGroupColors: secondGroupColors,
        patient_id: patientId,
      },
    })
  }

  public updateReport(reportId: number, report: BrushMapReport) {
    const { brushesFirm, teeth, firstGroupColors, secondGroupColors } = report

    return this.axiosCall({
      method: 'patch',
      url: '/api/web/admin/brush-maps/',
      data: {
        id: reportId,
        date_at: new Date(),
        brushesFirm: brushesFirm,
        teeth: teeth,
        firstGroupColors: firstGroupColors,
        secondGroupColors: secondGroupColors,
      },
    })
  }

  public removeReport(reportId: number) {
    return this.axiosCall({
      method: 'delete',
      url: `/api/web/admin/brush-maps/`,
      params: {
        id: reportId,
      },
    })
  }

  public sendEmail(reportId: number, sendCommentFiles: boolean) {
    const data = new FormData()
    data.append('report_id', reportId.toString())
    data.append('send_comment_files', sendCommentFiles ? 'true' : 'false')

    return this.axiosCall({
      method: 'post',
      url: '/api/web/admin/brush-maps/send-email',
      data,
    })
  }

  public sendReportToTelegramBot(reportId: number) {
    return this.axiosCall({
      method: 'post',
      url: `/api/web/admin/brush-maps/telegram/${reportId}`,
    })
  }

  public downloadPdf(reportId: number) {
    return this.axiosCall({
      method: 'get',
      url: `/api/web/admin/brush-maps/download-from-service/${reportId}`,
      responseType: 'blob',
    })
  }
}

export const brushReportApi = new BrushReportApi({
  baseURL:
    process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_URI : '',
  withCredentials: true,
})
